/**
 * Session token storage. The token is the opaque server session UUID returned by
 * POST /api/v1/auth/telegram and sent as `Authorization: Bearer <token>`.
 *
 * Kept in a module variable (read synchronously by the API middleware) and
 * mirrored to localStorage so a reload reuses the session until it expires.
 */
const STORAGE_KEY = 'vla.session.token'

let current: string | null = readInitial()

function readInitial(): string | null {
  try {
    return localStorage.getItem(STORAGE_KEY)
  } catch {
    return null
  }
}

export function getToken(): string | null {
  return current
}

export function setToken(token: string | null): void {
  current = token
  try {
    if (token) localStorage.setItem(STORAGE_KEY, token)
    else localStorage.removeItem(STORAGE_KEY)
  } catch {
    /* storage unavailable (private mode) — in-memory token still works */
  }
}
